<template>
  <div class="order">
    <div class="order-top">
      <div class="order-top-text">订单</div>
      <form class="f-box-flex1" action="form">
        <van-search placeholder="请输入搜索关键词" v-model="value" @search="onSearch" />
      </form>
    </div>
    <van-tabs v-model="active" @change="onChange">
      <van-tab title="全部"></van-tab>
      <van-tab title="待付款"></van-tab>
      <van-tab title="待发货"></van-tab>
      <van-tab title="待收货"></van-tab>
      <van-tab title="待评价"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="order-list">
        <!-- <div
          class="order-box"
          v-for="item in list"
          :key="item.id"
          v-touch:tap.prevent.stop="$gotoDetail(item.ORDER_ID)"
        >-->
        <router-link
          class="order-box"
          tag="div"
          v-for="item in list"
          :key="item.id"
          :to="{name:'HaiBoTangorderDetails',query:{orderId:item.ORDER_ID}}"
        >
          <div class="f-webkit-box order-box-top" v-for="j in item.ORDER_GOODS_DETAILS" :key="j.ID">
            <van-image :src="j.COVER_URL" radius="6" class="order-img" />
            <div class="f-box-flex1">
              <div class="order-title">{{j.PRODUCT_NAME}}</div>
              <div class="order-norms">规格：{{j.SKU_NAM}}</div>
              <div class="f-webkit-box">
                <div class="f-box-flex1 order-price">
                  <span>¥</span>
                  {{j.PRICE}}
                </div>
                <div class="f-box-flex1 order-number">x{{j.NUMBER}}</div>
              </div>
              <div class="f-webkit-box f-p-t-sm f-p-b-sm">
                <div class="f-box-flex1 order-total">共{{j.totalCount}}件</div>
                <div class="f-box-flex1 order-Subtotal">
                  小计：
                  <span>¥</span>
                  <span class="f-size-18">{{j.PRICE_REAL}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="f-webkit-box f-p-t-md">
            <div class="f-box-flex1 order-condition">{{ converCodeToText( item.ORDER_STATE)}}</div>
            <div class="f-box-flex1 order-btn">
              <!-- <div class="btn" v-touch:tap.stop="recieveConfirm(item.ORDER_ID)">确认收货</div> -->

              <template v-if="item.ORDER_STATE==101">
                <div class="btn" v-touch:tap.stop="cancelOrder(item.ORDER_ID)">取消</div>
                <div class="btn">待支付</div>
              </template>

              <template v-else-if="item.ORDER_STATE==401 || item.ORDER_STATE===402">
                <div class="btn" v-touch:tap.stop="deleteOrder(item.ORDER_ID)">删除</div>
              </template>
              <template v-else-if="item.ORDER_STATE==201">
                <!-- <router-link
                  class="btn"
                  tag="div"
                  :to="{name:'refunds',query:{orderId:item.ORDER_ID}}"
                >申请退款</router-link>-->
                <div
                  class="btn"
                  v-touch:tap.stop.prevent="requestRefund(item.ORDER_ID,item.SELLERRES)"
                >申请退款</div>
              </template>
              <template v-else-if="item.ORDER_STATE==205">
                <router-link
                  class="btn"
                  tag="div"
                  :to="{name:'HaiBoTangorderDetails',query:{orderId:item.ORDER_ID}}"
                >退款中</router-link>
              </template>
              <template v-else-if="item.ORDER_STATE==405">
                <div class="btn" v-touch:tap.stop="deleteOrder(item.ORDER_ID)">删除</div>
                <div class="btn" v-touch:tap.stop="orderRefundSuccessful(item.ORDER_MONEY)">退款成功</div>
              </template>
              <template v-else-if="item.ORDER_STATE==202">
                <div class="btn" v-touch:tap="recieveConfirm(item.ORDER_ID)">确认收货</div>
                <div
                  class="btn"
                  v-touch:tap.stop.prevent="requestRefund(item.ORDER_ID,item.SELLERRES)"
                >申请退款</div>
              </template>
              <template v-else-if="item.ORDER_STATE==303">
                <router-link
                  class="btn"
                  tag="div"
                  :to="{name:'appraisals',query:{orderId:item.ORDER_ID}}"
                >评价</router-link>
              </template>
              <template v-else-if="item.ORDER_STATE==304 ">
                <!-- <div class="btn">已评价</div> -->
              </template>
            </div>
          </div>
          <!-- <div class="f-webkit-box f-p-t-md" >
                <div class="f-box-flex1 order-condition">{{item.condition}}</div>
          </div>-->
        </router-link>
      </div>
    </van-list>
  </div>
</template>
<script>
import { Tab, Tabs, Search, List } from "vant";
import http from "@js/http-hbt.js";
import {
  getUserOrderList,
  deleteOrder,
  cancelOrder,
  recieveConfirm
} from "@js/shoppingUrl.js";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Search.name]: Search,
    [List.name]: List
  },
  data() {
    return {
      value: "", //搜索
      active: 0, //默认选中

      list: [],
      loading: false,
      finished: false
    };
  },
  computed: {
    userId() {
      return "6a09b8a91f174129a35ceb39a6171c8f";
      return this.$store.state.userInfo.userId;
    },
    getImagePrefix() {
      return this.$store.state.shoppingBlock.bgImgPrefix || "";
    }
  },
  created() {},
  inject: ["reload"],
  methods: {
    converCodeToText(code) {
      let config = {
        101: "待支付",
        200: "待确认",
        201: "待发货",
        202: "待收货",
        203: "待发货",
        205: "退款中",
        301: "消费中",
        302: "已消费",
        303: "交易成功",
        304: "已评价",
        401: "已取消（商家）",
        402: "已取消（买家）",
        502: "异步下单成功",
        503: "分销退款中",
        504: "分销下单其他异常",
        502: "异步下单成功",
        503: "分销退款中",
        405: "已退款：",
        403: "已取消（管理员）",
        404: "已取消（系统）",
        405: "退款成功"
      };

      return config[code];
    },
    onLoad() {
      this.loading = true;
      let params = {
        userId: this.userId,
        type: this.active,
        keyword: this.value,
        siteId: "",
        offset: this.list.length,
        psize: 5
      };
      this.getUserOrderList(params);
    },
    onChange(name, title) {
      this.active = name;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    getUserOrderList(params) {
      http
        .post(getUserOrderList, params, {loading: false})
        .then(({ data }) => {
          if (data == "" || data.length === 0) {
            this.finished = true;
            return;
          }
          data.map(item => {
            item.ORDER_GOODS_DETAILS.map(j => {
              j.COVER_URL = this.getImagePrefix + j.COVER_URL;
            });
          });

          this.list = this.list.concat(data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //查看物流
    specifications() {
      return () => {
        // this.$router.push({ path: "headlinesDetailed",query: {}}).catch(err => {
        //     err;
        // });
      };
    },
    //确认收货
    recieveConfirm(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认收货"
          })
          .then(() => {
            http
              .post(recieveConfirm, {
                orderId,
                userId: this.userId
              })
              .then(res => {
                this.$toastSuccessReload();
              });
          });
      };
    },
    //海博堂订单详情
    $gotoDetail(orderId) {
      return () => {
        this.$router.push({
          path: "HaiBoTangorderDetails",
          query: { orderId }
        });
      };
    },
    //评价
    appraisals(id) {
      return () => {
        this.$router
          .push({ path: "appraisals", query: { id: id } })
          .catch(err => {
            err;
          });
      };
    },
    onSearch() {
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    deleteOrder(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认删除?"
          })
          .then(() => {
            http
              .post(deleteOrder, {
                userId: this.userId,
                orderId
              })
              .then(res => {
                this.$toastSuccessReload("已删除该订单");
              });
          });
      };
    },
    cancelOrder(orderId) {
      return () => {
        this.$dialog
          .confirm({
            message: "是否确认取消？"
          })
          .then(() => {
            http
              .post(cancelOrder, {
                orderId,
                userId: this.userId
              })
              .then(res => {
                this.$toastSuccessReload("已取消该订单");
              });
          });
      };
    },
    $toastSuccessReload(message = "操作成功") {
      let tiemr = setTimeout(() => {
        clearTimeout(tiemr);
        this.$toast(
          {
            type: "success",
            message,
            duration: 3000,
            onClose: () => {
              this.reload();
            }
          },
          50
        );
      });
    },
    orderRefundSuccessful(price) {
      return () => {
        this.$dialog.alert({
          message: `您的退款将在3-15个工作日内原路返回您的账户，退款总金额:￥${price}`
        });
      };
    },
    requestRefund(orderId, sellerres) {
      return () => {
        if (sellerres) {
          this.$dialog.alert({
            message: `申请失败，卖家已拒绝您的申请，${sellerres},请联系客服电话：0898-65238891`
          });
        } else {
          this.$router.push({
            name: "refunds",
            query: { orderId }
          });
        }
      };
    }
  }
};
</script>

<style lang="less" scoped>
.order {
  background-color: #eff0fa !important;
  .order-top {
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-flex;
    display: -moz-box;
    display: -ms-flex;
    display: -ms-box;
    // display: box;
    display: flex;
    .order-top-text {
      width: 78px;
      height: 54px;
      line-height: 54px;
      color: #343434;
      font-size: 14px;
      text-align: center;
      background-color: #fff;
    }
    .f-box-flex1 {
      overflow: hidden;
      box-flex: 1;
      -webkit-box-flex: 1;
      -moz-box-flex: 1;
      flex: 1;
      -webkit-flex: 1;
    }
  }
  .order-list {
    padding: 8px 7px;
    .order-box {
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      padding: 18px 12px;
      margin-bottom: 10px;
      .order-box-top {
        border-bottom: 1px solid #e7e7e7;
        .order-img {
          width: 86px;
          height: 84px;
          margin-right: 10px;
        }
        .order-title {
          color: #1a1b1d;
          font-size: 12px;
          line-height: 18px;
        }
        .order-norms {
          color: #1a1b1d;
          font-size: 12px;
          line-height: 18px;
          padding: 6px 0;
        }
        .order-price {
          color: #ff7613;
          font-size: 18px;
          font-weight: 500;
          line-height: 20px;
          text-align: left;
          span {
            font-size: 14px;
          }
        }
        .order-number {
          color: #1a1b1d;
          font-size: 12px;
          line-height: 20px;
          text-align: right;
        }
        .order-total {
          font-size: 12px;
          color: #797979;
          line-height: 18px;
          text-align: left;
        }
        .order-Subtotal {
          color: #797979;
          font-size: 12px;
          text-align: right;
          span {
            color: #ff7613;
            font-size: 14px;
            .f-size-18 {
              font-size: 18px;
            }
          }
        }
      }
      .order-condition {
        color: #ff7613;
        line-height: 22px;
        font-weight: 500;
        font-size: 12px;
      }
      .order-btn {
        text-align: right;
        .btn {
          display: inline-block;
          border-radius: 11px;
          border: 1px solid rgba(213, 213, 213, 1);
          width: 72px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          color: #666666;
          font-size: 12px;
          margin: 0 5px;
        }
      }
    }
  }
  .f-p-t-md {
    padding-top: 20px;
  }
  .f-p-t-sm {
    padding-top: 10px;
  }
  .f-p-b-sm {
    padding-bottom: 10px;
  }
  .f-box-flex1 {
    overflow: hidden;
    box-flex: 1;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
  }
  .f-webkit-box {
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-flex;
    display: -moz-box;
    display: -ms-flex;
    display: -ms-box;
    // display: box;
    display: flex;
  }
}
</style>